import { Card, CardContent, Typography, Dialog, DialogContent, Table, TableBody, TableCell, TableHead, TableRow, Button } from '@mui/material';
import dayjs from 'dayjs';

const MarketDetailDialog = ({ open, onClose, selectedItem, formattedDate, handleRedirect }) => {
    if (!selectedItem) return null;
    const sortedBuy = [...(selectedItem?.depth?.buy || [])].sort((a, b) => b.price - a.price) ?? [];
    const sortedSell = [...(selectedItem?.depth?.sell || [])].sort((a, b) => a.price - b.price) ?? [];
    return (
        <Dialog
            open={open}
            onClose={onClose}
            sx={{
                position: 'fixed',
                left: 0,
                right: 2,
                bottom: 0,
                margin: 0,
                display: 'flex',
                flexDirection: 'column',
                overflow: 'auto',
                boxSizing: 'border-box',
                top: 'auto',
            }}
            PaperProps={{
                sx: {
                    borderRadius: '20px 20px 0 0',
                    transition: 'transform 0.4s ease-in-out',
                    transform: open ? 'translateY(0)' : 'translateY(100vh)',
                    maxHeight: '90vh',
                    height: '100vh',
                    margin: '10px',
                    // width: '33vw',
                    maxWidth: '400px',
                    bgcolor: 'gray.50',
                },
            }}
        >
            <DialogContent
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    flexGrow: 1,
                    overflowY: 'auto',
                    '&::-webkit-scrollbar': { width: '1px' },
                    '&::-webkit-scrollbar-track': { backgroundColor: 'transparent' },
                    '&::-webkit-scrollbar-thumb': { backgroundColor: 'transparent' },
                    p: 2,
                }}
            >
                <div className="w-full">
                    <div className="flex flex-wrap justify-between items-center pb-1  ">
                        <div className="flex items-center gap-3">
                            <span className="font-lato font-semibold text-black text-[14px]  ">
                                {selectedItem?.tradingSymbol || 'N/A'}
                            </span>
                            <span className="font-lato text-black  text-[12px] font-medium uppercase py-1 px-2 rounded-sm">
                                {selectedItem?.exchange || 'N/A'}
                            </span>
                        </div>
                        <span className="font-lato font-semibold text-[#089981] text-[18px]  ">
                            {selectedItem?.avgPrice?.toFixed(2) || 'N/A'}
                        </span>
                    </div>

                    {/* Additional Info */}
                    <div className="flex justify-between items-center">
                        <span className="text-[#f23645] text-[12px]">
                            Lots size: {selectedItem?.lastTradeQty || 'N/A'}
                        </span>
                        <span className="text-gray-500 text-[12px]">
                            {selectedItem?.netChange >= 0
                                ? `+${selectedItem?.netChange || 0}`
                                : selectedItem?.netChange || 0}
                            {` (`}{selectedItem?.percentChange || 0}{`%)`}
                        </span>
                    </div>

                    {/* OHLC Card */}
                    <Card className="rounded-md h-[60px] w-full mt-1">
                        <CardContent>
                            <div className="flex items-center justify-between -mt-[5px]">
                                {['Open', 'High', 'Low', 'Close'].map((label) => (
                                    <div key={label} className="flex flex-col items-center gap-1">
                                        <span className="font-lato text-sm text-gray-500">{label}</span>
                                        <span className="font-lato text-sm">
                                            {selectedItem?.[label.toLowerCase()] || 'N/A'}
                                        </span>
                                    </div>
                                ))}
                            </div>
                        </CardContent>
                    </Card>

                    {/* Market Depth Table */}
                    <div className="mt-2 overflow-hidden">
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell className="font-lato text-[14px] font-normal text-left p-1 border-none whitespace-nowrap leading-[17px]">QTY</TableCell>
                                    <TableCell className="font-lato text-[14px] font-normal text-right p-1 border-none whitespace-nowrap leading-[17px]">BUY PRICE</TableCell>
                                    <TableCell className="font-lato text-[14px] font-normal text-left p-1 border-none whitespace-nowrap leading-[17px]">SELL PRICE</TableCell>
                                    <TableCell className="font-lato text-[14px] font-normal text-right p-1 border-none whitespace-nowrap leading-[17px]">QTY</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody className="bg-white rounded-lg overflow-hidden">
                                {sortedBuy.length > 0 ? (
                                    sortedBuy.map((buyOrder, index) => {
                                        const sellOrder = sortedSell[index] || {};
                                        return (
                                            <TableRow key={index}>
                                                <TableCell className="font-lato text-left p-2 border-0 text-black text-[16px] font-normal leading-[19px] align-middle">
                                                    {buyOrder?.quantity || 'N/A'}
                                                </TableCell>
                                                <TableCell className="font-lato text-right p-2 border-0 text-[#089981] text-[16px] font-normal leading-[19px] align-middle">
                                                    {buyOrder?.price || 'N/A'}
                                                </TableCell>
                                                <TableCell className="font-lato text-left p-2 border-0 text-[#f23645] text-[16px] font-normal leading-[19px] align-middle">
                                                    {sellOrder?.price || 'N/A'}
                                                </TableCell>
                                                <TableCell className="font-lato text-right p-2 border-0 text-black text-[16px] font-normal leading-[19px] align-middle">
                                                    {sellOrder?.quantity || 'N/A'}
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })
                                ) : (
                                    <TableRow>
                                        <TableCell colSpan={4} className="font-lato text-center p-2 text-gray-500">
                                            No market depth data available
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </div>

                    {/* Additional Details */}
                    <div className="mt-1">
                        {[
                            { label: 'Volume', value: selectedItem?.tradeVolume || 'N/A' },
                            { label: 'Last traded quantity', value: selectedItem?.lastTradeQty || 'N/A' },
                            { label: 'Last traded at', value: selectedItem?.exchTradeTime ? dayjs(selectedItem.exchTradeTime).format("YYYY-MM-DD HH:mm:ss") : 'N/A' },
                            { label: 'Lower circuit', value: selectedItem?.lowerCircuit || 'N/A' },
                            { label: 'Upper circuit', value: selectedItem?.upperCircuit || 'N/A' },
                        ].map(({ label, value }) => (
                            <div key={label} className="flex justify-between items-center p-1">
                                <span className="font-lato text-gray-600 text-[14px]">{label}</span>
                                <span className="font-lato text-[14px] text-black">{value}</span>
                            </div>
                        ))}
                    </div>

                    {/* Buy & Sell Buttons */}
                    <div className="mt-auto flex justify-center flex-row gap-6 mb-[20px]">
                        <Button
                            variant="outlined"
                            className="font-lato rounded-[8px] bg-[#089981] text-white border-[#089981] py-[7px] px-[33px] text-[16px] font-semibold leading-[20px] flex flex-col items-center"
                            onClick={() =>
                                handleRedirect(
                                    'buy',
                                    selectedItem?.tradingSymbol,
                                    selectedItem?.exchange,
                                    selectedItem?.depth?.sell[0]?.price,
                                    selectedItem?.lots,
                                    selectedItem?.netChange,
                                    selectedItem?.percentChange,
                                    selectedItem?.symbolToken,
                                    selectedItem?.lowerCircuit,
                                    selectedItem?.upperCircuit,
                                    selectedItem?.high,
                                    selectedItem?.low,
                                    selectedItem?.script_id,
                                    selectedItem?.exchange_id,
                                    formattedDate
                                )
                            }
                            disabled={!selectedItem?.depth?.sell[0]?.price}
                        >
                            <span>BUY</span>
                            <span className="font-lato text-[12px]">@ {selectedItem?.depth?.sell[0]?.price || 'N/A'}</span>
                        </Button>
                        <Button
                            variant="outlined"
                            className="font-lato rounded-[8px] bg-[#f23645] text-white border-[#f23645] py-[7px] px-[33px] text-[16px] font-semibold leading-[20px] flex flex-col items-center"
                            onClick={() =>
                                handleRedirect(
                                    'sell',
                                    selectedItem?.tradingSymbol,
                                    selectedItem?.exchange,
                                    selectedItem?.depth?.buy[0]?.price,
                                    selectedItem?.lots,
                                    selectedItem?.netChange,
                                    selectedItem?.percentChange,
                                    selectedItem?.symbolToken,
                                    selectedItem?.lowerCircuit,
                                    selectedItem?.upperCircuit,
                                    selectedItem?.high,
                                    selectedItem?.low,
                                    selectedItem?.script_id,
                                    selectedItem?.exchange_id,
                                    formattedDate
                                )
                            }
                            disabled={!selectedItem?.depth?.buy[0]?.price}
                        >
                            <span>SELL</span>
                            <span className="font-lato text-[12px]">@ {selectedItem?.depth?.buy[0]?.price || 'N/A'}</span>
                        </Button>
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default MarketDetailDialog;